<template>
  <div
    class="bet"
    v-if="bet"
    :class="[ 'bet-' + this.betLength, { disabled: disabled } ]">
    <div class="outcomes">
      <div
        class="outcome-wrapper"
        v-for="outcome in outcomes"
        :key="outcome.idBetOutcome">
        <div
          @click="addToBetslip(bet, outcome)"
          class="outcome"
          :class="{ 'special-value': outcome.isSpecial, active: addedToBetslip(outcome),
                    'change-up': outcome.change == 'UP', 'change-down': outcome.change == 'DOWN' }">
          {{ outcome.display && outcome.display[oddType] ?
          outcome.display[oddType] : outcome.value }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    oddType() {
      return this.$store.getters.getActiveOddType;
    },
    betLength() {
      if (this.bet.specialValue !== '*') {
        return this.bet && this.bet.outcomes ? this.bet.outcomes.length + 1 : 1;
      }
      return this.bet && this.bet.outcomes ? this.bet.outcomes.length : 0;
    },
    hasSpecialValue() {
      return this.bet.specialValue !== '*';
    },
    outcomes() {
      if (!this.hasSpecialValue) {
        return this.bet.outcomes;
      }
      const outcomes = [];
      const specialOutcome = {
        isSpecial: true,
        value: this.bet.specialValue,
      };

      if (this.bet.outcomes) {
        this.bet.outcomes.forEach((outcome, index) => {
          if (index === 0) {
            outcomes.push(outcome);
            outcomes.push(specialOutcome);
          } else {
            outcomes.push(outcome);
          }
        });
      }

      return _.filter(outcomes, o => o.value);
    },
    betslipBets() {
      return this.$store.getters.getBetslipBets;
    },
    disabled() {
      const metaBet = this.$store.getters.getBetById(this.bet.id);
      return (metaBet && !metaBet.active) || (this.bet && !this.bet.active);
    },
  },
  props: {
    bet: {
      type: Object,
      required: true,
      default: () => {},
    },
    match: {
      type: Object,
      required: true,
      default: () => {},
    },
    topOffer: {
      type: Number,
      required: true,
    },
  },
  methods: {
    getBet() {
      return this.$store.state.bets[this.bet.id];
    },
    addToBetslip(bet, outcome) {
      if (outcome.isSpecial || !outcome.value) return;

      const getOutcome = ({ id }) => _.find(this.getBet().outcomes, { id });

      const parsedBet = {
        key: outcome.idMatchBetOutcome,
        keyBet: bet.id,
        idMatchBet: bet.idMatchBet,
        matchDisplayId: this.match.displayId,
        matchDateTimeUTC: this.match.timestampUTC,
        keyOutcome: outcome.idMatchBetOutcome,
        matchId: this.match.id,
        title: this.match.name,
        subtitle: bet.name,
        outcome: outcome.name || getOutcome(outcome).name,
        oddValue: outcome.value,
        oddDisplay: outcome.display,
        specialValue: this.bet.specialValue,
        banker: false,
        change: null,
      };

      this.$store.dispatch('addBetToBetslip', parsedBet);
    },
    addedToBetslip(outcome) {
      return _.findIndex(this.betslipBets, { key: outcome.idMatchBetOutcome }) !== -1;
    },
    getOutcomes(bet) {
      return bet.outcomes || [];
    },
  },
};
</script>

<style lang="scss">
  .bet {
    position: relative;
    overflow: hidden;
    width: 100/3 * 1%;
    float: left;
    min-height: 65px;
    border-right: 5px solid #171717;

    &.disabled:after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(#000, 0.5);
      width: 100%;
      height: 100%;
      content: "\e6b7";
      font-family: NFont;
      font-size: 30px;
      text-align: center;
      line-height: 60px;
      z-index: 1;

    }

    &:last-child {
      margin-right: 0;
    }

    &-2 {
      .outcome-wrapper {
        width: 50%;
      }
    }
  }

  .outcome-wrapper {
    float: left;
    height: 100%;
    color: #e6e6e6;
    width: 100/3 * 1%;
    text-align: center;
    line-height: 55px;
    padding: 5px 4px;
    font-size: 20px;
  }

  .outcome {
    position: relative;
    transition: background 500ms;

    .odd-value {
      font-family: 'Open Sans', sans-serif;
    }
  }

  .outcome:not(.special-value) {
    background: #424242;

    &.change-up:before {
      width: 0;
      height: 0;
      content: " ";
      border-top: 20px solid #2e7d32;
      border-left: 20px solid transparent;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1000;
    }

    &.change-down:before {
      width: 0;
      height: 0;
      content: " ";
      border-bottom: 20px solid #7d2e2e;
      border-left: 20px solid transparent;
      position: absolute;
      bottom: 0;
      right: 0;
      z-index: 1000;
    }

    &.active {
      background: #685834;
    }
  }

  .special-value {
    color: #ffb300;
  }
</style>
